export type ITag = {
  id: number;
  documentId: string;
  title: string;
  description: string;
  color: string;
  subGenres?: Array<
    | string
    | { documentId?: string; title?: string; name?: string; label?: string }
  >;
};

export const TagEmptyObject: ITag = {
  color: "",
  description: "",
  documentId: "",
  id: 0,
  title: "",
};

export type ITagType = "genre" | "feeling";
